import attachmentMergeTemplate from './attachmentMerge.template.html';

export default {
  template: attachmentMergeTemplate,
  bindings: {
    complianceFileLabels: '<',
    documents: '<',
    specificDocuments: '<',
    lenders: '<',
    validationErrors: '<',
    ticket: '<',
    workflow: '<',
    assetFinance: '<',
    homeLoan: '<',
    hasAssetFinanceTools: '<',
    hasHomeLoanTools: '<',
    showPdfService: '<',
    showSpecificDocuments: '<',
    showActions: '<',
    onCreatePdf: '&',
    onCancelled: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdMedia,
      uiService,
      eventService,
      documentService,
      helperService,
      TransactionType
    ) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentAccount = null;
      ctrl.organizationCountry = null;
      ctrl.availablePdfTypes = [];
      ctrl.mergeDocuments = [];
      ctrl.complianceMergeDocuments = [];
      ctrl.requiredComplianceLabels = [];
      ctrl.limit = {
        standard: 8,
        compliance: 8
      };

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.canSeeAssetFinanceTools = $rootScope.canSeeAssetFinanceTools();
        ctrl.showPrivacyDisclosure = !$rootScope.isPtf() && !$rootScope.isNlg();
        ctrl.currentAccount = $rootScope.CurrentAccount;
        ctrl.availablePdfTypes = helperService.getAvailablePdfTypes();
        ctrl.availableComplianceTypes = helperService.getAvailableComplianceTypes();
        ctrl.availableClientTypesForCreateDocumentsOption =
          helperService.getAvailableClientTypesForCreateDocumentsOption();

        ctrl.complianceFileLabels = ctrl.complianceFileLabels || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.specificDocuments = ctrl.specificDocuments || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.ticket = ctrl.ticket || {};
        ctrl.workflow = ctrl.workflow || {};
        ctrl.assetFinance = ctrl.assetFinance || {};
        ctrl.homeLoan = ctrl.homeLoan || {};
        ctrl.preferredProduct = null;
        ctrl.hasAssetFinanceTools = ctrl.hasAssetFinanceTools || false;
        ctrl.hasHomeLoanTools = ctrl.hasHomeLoanTools || false;
        ctrl.showPdfService = ctrl.showPdfService || false;
        ctrl.showSpecificDocuments = ctrl.showSpecificDocuments || false;
        ctrl.showActions = ctrl.showActions || false;

        _.forEach(ctrl.documents, (d) => {
          const doc = d;
          doc.isSelected = false;
          return doc;
        });
        _.forEach(ctrl.specificDocuments, (d) => {
          const doc = d;
          doc.isSelected = false;
          return doc;
        });
        const complianceIdLabels = _.compact(_.map(ctrl.complianceFileLabels, 'id'));
        ctrl.standardDocuments = _.filter(ctrl.documents, (d) =>
          _.every(d.idLabels, (l) => complianceIdLabels.indexOf(l) === -1)
        );
        ctrl.complianceDocuments = _.filter(ctrl.documents, (d) =>
          _.some(d.idLabels, (l) => complianceIdLabels.indexOf(l) > -1)
        );

        ctrl.requiredComplianceLabels = _.map(
          _.filter(
            ctrl.availableComplianceTypes,
            (d) => d.isRequired && d.isRequiredForCompliance
          ),
          'value'
        );
        ctrl.mergeDocuments = [];
        ctrl.alertComplianceMessages = [];
        ctrl.showComplianceDocuments = false;
        ctrl.isComplianceReady = false;
        ctrl.isSpecificReady = false;
        ctrl.isTicketImportedAndNotArchived = ctrl.ticket.isImported
          ? !ctrl.ticket.isWon &&
            !ctrl.ticket.isLost &&
            !ctrl.ticket.isFrozen &&
            ctrl.ticket.isActive
          : true;
        ctrl.startSaveProcess = !ctrl.mergeDocuments?.length;
        ctrl.showMoreStandard = false;
        ctrl.showMoreCompliance = false;
        ctrl.showMoreSpecific = false;
        ctrl.clientTypeOption = ctrl.availableClientTypesForCreateDocumentsOption[0]?.id || '';
        ctrl.setComplianceChecks();
      };

      ctrl.hasPreferredProduct = () => {
        if (ctrl.hasAssetFinanceTools) {
          ctrl.preferredProduct = helperService.getPreferredProduct({
            products: ctrl.assetFinance?.compareProducts || []
          });
        }
        if (ctrl.hasHomeLoanTools) {
          ctrl.preferredProduct = helperService.getPreferredProduct({
            products: ctrl.homeLoan?.compareProducts || []
          });
        }
        return ctrl.preferredProduct !== undefined;
      };

      ctrl.canSeeApplicationSummary = () => {
        if (ctrl.hasHomeLoanTools) {
          ctrl.preferredProduct = helperService.getPreferredProduct({
            products: ctrl.homeLoan?.compareProducts || []
          });
        }
        if (!ctrl.preferredProduct) {
          return false;
        }
        return !helperService.isLoanworksGatewaySelected({
          idLender: ctrl.preferredProduct?.idLender
        });
      };

      ctrl.setComplianceChecks = () => {
        ctrl.hasPreferredProduct();
        let compliance = {};
        if (ctrl.workflow?.isAssetFinance()) {
          ctrl.showComplianceDocuments =
            ctrl.hasAssetFinanceTools && ctrl.isTicketImportedAndNotArchived;
          compliance = ctrl.assetFinance?.compliance || {};
        }
        if (ctrl.workflow?.isHomeLoan()) {
          ctrl.showComplianceDocuments =
            ctrl.hasHomeLoanTools && ctrl.isTicketImportedAndNotArchived;
          compliance = ctrl.homeLoan?.compliance || {};
        }
        ctrl.isComplianceReady = helperService.getStatusOfRequiredComplianceFields({
          products: ctrl.homeLoan?.reviewProducts || ctrl.assetFinance?.compareProducts || [],
          validationErrors: ctrl.validationErrors || [],
          compliance,
          objectives: ctrl.ticket?.objectives || {},
          commission: ctrl.homeLoan?.commission || ctrl.assetFinance?.commission || {},
          isCommercial: ctrl.assetFinance?.isCommercial || false,
          hasAssetFinanceTools: ctrl.hasAssetFinanceTools,
          hasHomeLoanTools: ctrl.hasHomeLoanTools,
          idPreferredLender: ctrl.preferredProduct?.idLender,
          isDocument: true
        });
        if (!ctrl.isComplianceReady) {
          const complianceMessages = [
            'Some mandatory fields are not completed.',
            'Please check Commissions and Compliance comments & documents tabs for any highlighted fields.'
          ];
          const errorMessages = [];
          const eLen = ctrl.validationErrors?.length || 0;
          for (let e = 0; e < eLen; e += 1) {
            const error = ctrl.validationErrors[e];
            errorMessages.push(error?.message);
          }
          ctrl.alertComplianceMessages = complianceMessages.concat(errorMessages);
        }
        ctrl.isSpecificReady = helperService.getStatusOfRequiredComplianceFields({
          products: ctrl.homeLoan?.reviewProducts || ctrl.assetFinance?.compareProducts || [],
          validationErrors: ctrl.validationErrors || [],
          compliance,
          objectives: ctrl.ticket?.objectives || {},
          commission: ctrl.homeLoan?.commission || ctrl.assetFinance?.commission || {},
          hasAssetFinanceTools: ctrl.hasAssetFinanceTools,
          hasHomeLoanTools: ctrl.hasHomeLoanTools,
          idPreferredLender: ctrl.preferredProduct?.idLender,
          isDocument: true
        });
      };

      ctrl.hasAmortizationSchedulesData = () =>
        ctrl.assetFinance?.financeProposal?.amortizationSchedules?.length;

      ctrl.hasFundingWorksheetsData = () =>
        ctrl.homeLoan?.fundingWorksheets?.fundsRequired?.length;

      ctrl.hasCompareProductsData = () => {
        if (ctrl.hasAssetFinanceTools) {
          return ctrl.assetFinance?.compareProducts?.length;
        }
        if (ctrl.hasHomeLoanTools) {
          return ctrl.homeLoan?.compareProducts?.length;
        }
        return false;
      };

      ctrl.hasRefinanceAnalysisData = () =>
        _.some(
          ctrl.homeLoan?.fundingWorksheets?.fundsRequired || [],
          (f) =>
            f?.transactionType?.name === TransactionType.refinance.name ||
            f?.transactionType?.name === TransactionType.equity_release.name
        );

      ctrl.showApplicationPdf = () =>
        helperService.showOptionForCreatingPdfApplication({
          workflow: ctrl.workflow || {},
          hasAssetFinanceTools: ctrl.hasAssetFinanceTools,
          hasHomeLoanTools: ctrl.hasHomeLoanTools
        });

      ctrl.canCreatePdf = () => {
        if (
          ctrl.workflow?.isAssetFinance() &&
          ctrl.hasAssetFinanceTools &&
          ctrl.canSeeAssetFinanceTools
        ) {
          return (
            ctrl.showApplicationPdf() ||
            ctrl.showPrivacyDisclosure ||
            ctrl.hasAmortizationSchedulesData()
          );
        }
        if (ctrl.workflow?.isHomeLoan() && ctrl.hasHomeLoanTools) {
          return (
            ctrl.showApplicationPdf() ||
            ctrl.hasFundingWorksheetsData() ||
            ctrl.lenders?.length ||
            ctrl.hasCompareProductsData() ||
            ctrl.hasRefinanceAnalysisData()
          );
        }
        return false;
      };

      ctrl.createPdf = ({ pdfType }) => {
        if (pdfType === ctrl.availablePdfTypes[0]) {
          const alert = helperService.showAlertForCreatingPdfApplication({
            products: ctrl.workflow?.isAssetFinance()
              ? ctrl.assetFinance?.compareProducts || []
              : ctrl.homeLoan?.compareProducts || [],
            compliance: ctrl.workflow?.isAssetFinance()
              ? ctrl.assetFinance?.compliance || {}
              : ctrl.homeLoan?.compliance || {},
            objectives: ctrl.ticket?.objectives || {},
            commission: ctrl.workflow?.isAssetFinance()
              ? ctrl.assetFinance?.commission || {}
              : ctrl.homeLoan?.commission || {},
            workflow: ctrl.workflow || {},
            hasAssetFinanceTools: ctrl.hasAssetFinanceTools,
            hasHomeLoanTools: ctrl.hasHomeLoanTools,
            isDocument: true
          });
          if (alert?.alerts?.length) {
            alert.title =
              ctrl.organizationCountry.cca2 !== 'NZ'
                ? 'Error - Save application summary'
                : 'Error - Save application form';
            eventService.alertDialog({ alert });
          } else {
            ctrl.onCreatePdf({ pdfType });
          }
        } else {
          ctrl.onCreatePdf({ pdfType });
        }
      };

      ctrl.select = ({ template }) => {
        const file = template;
        file.isSelected = !file.isSelected;
        const idx = _.findIndex(ctrl.mergeDocuments, (d) => d.id === file.id);
        if (idx === -1) {
          ctrl.mergeDocuments.push(file);
        } else {
          ctrl.mergeDocuments.splice(idx, 1);
        }
        ctrl.startSaveProcess = !ctrl.mergeDocuments?.length;
        if (!ctrl.showActions) {
          ctrl.onFinished({ mergeDocuments: ctrl.mergeDocuments });
        }
      };

      ctrl.getLabel = ({ idLabel }) =>
        _.find(ctrl.complianceFileLabels, (l) => l?.id === idLabel);

      ctrl.canSelect = ({ template }) => {
        const isComplianceFileHasRequiredLabels = _.some(template?.idLabels || [], (l) => {
          const label = ctrl.getLabel({ idLabel: l });
          const name = label ? label?.getName() || 'N/A' : 'N/A';
          return ctrl.requiredComplianceLabels.indexOf(name) > -1;
        });
        return isComplianceFileHasRequiredLabels ? ctrl.isComplianceReady : true;
      };

      ctrl.toggleShowMore = ({ template }) => {
        if (template === 'standard') {
          ctrl.showMoreStandard = !ctrl.showMoreStandard;
          ctrl.limit.standard = ctrl.showMoreStandard ? undefined : 8;
        }
        if (template === 'compliance') {
          ctrl.showMoreCompliance = !ctrl.showMoreCompliance;
          ctrl.limit.compliance = ctrl.showMoreCompliance ? undefined : 8;
        }
        if (template === 'specific') {
          ctrl.showMoreSpecific = !ctrl.showMoreSpecific;
          ctrl.limit.compliance = ctrl.showMoreSpecific ? undefined : 8;
        }
      };

      ctrl.cancel = () => {
        if (!ctrl.showSpecificDocuments) {
          ctrl.startSaveProcess = true;
          ctrl.onCancelled();
          $timeout(() => {
            ctrl.initialize();
          });
        }
      };

      ctrl.confirm = () => {
        if (!ctrl.showSpecificDocuments) {
          ctrl.startSaveProcess = true;
          const idDocuments = _.map(ctrl.mergeDocuments, 'id');
          if (idDocuments.length) {
            uiService.toast({
              text: {
                p1: 'Document template',
                p2: 'is being prepared',
                p3: 'please wait'
              },
              progress: true
            });
            documentService
              .mergeDocument({
                idWorkflow: ctrl.ticket.idWorkflow,
                idStage: ctrl.ticket.idStage,
                idTicket: ctrl.ticket.id,
                idDocuments,
                filterByContact: ctrl.clientTypeOption
              })
              .then((result) => {
                if (!result.status) {
                  uiService.toast({
                    text: {
                      p1: 'Document',
                      p2: 'merge',
                      p3: 'has failed'
                    },
                    warn: true
                  });
                } else {
                  ctrl.onFinished({ status: result.status });
                  uiService.toast({
                    text: {
                      p1: 'Document',
                      p2: 'merged',
                      p3: 'successfully'
                    }
                  });
                }
                ctrl.cancel();
              });
          } else {
            uiService.toast({
              text: {
                p1: 'Please select',
                p2: 'some document(s)',
                p3: 'from the list'
              },
              warn: true
            });
          }
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
